import { render, staticRenderFns } from "./angielacoquette.vue?vue&type=template&id=47567da2&scoped=true"
import script from "./angielacoquette.vue?vue&type=script&lang=ts"
export * from "./angielacoquette.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47567da2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AngielacoquetteContents: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/angielacoquette/contents/contents.vue').default})
